<div class="custom-form main-form">
	<div [formGroup]="formGroup" *ngIf="formInitialized$ | async; else loading">
		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">{{ 'AL.LINK_NAME' | translate: locale.language }}</label>
			</div>
			<div class="setting-field">
				<dx-text-box as-validator formControlName="name"></dx-text-box>
			</div>
		</div>

		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">{{ 'AL.EXPIRY_DATE' | translate: locale.language }}</label>
			</div>
			<div class="setting-field">
				<div class="expiry-settings">
					<dx-date-box class="expiry-date-field" as-validator [displayFormat]="dateFormat" [width]="186" formControlName="expiryDate"></dx-date-box>
					<dx-check-box *ngIf="canManageLinkExpiry" formControlName="excludeFromExpiryNotificationMail" text="Exclude from expiry mail"></dx-check-box>
				</div>
			</div>
		</div>

		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">{{ 'AL.DELETE_LINK' | translate: locale.language }}</label>
			</div>
			<div class="setting-field">
				<button style="position: relative; top:-5px; scale:0.75; transform-origin: left;" (click)="deleteLink()" type="button" class="btn btn-danger">Delete link</button>
			</div>
		</div>

		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">{{ 'AL.RESET_WARNINGS_VISIBILITY' | translate: locale.language }}<tooltip-circle tooltipId="resetwarningstooltip">
									<div class="basic-tooltip-text" [innerHtml]="'AL.RESET_WARNINGS_VISIBILITY_EXPLANATION' | translate: locale.language"></div></tooltip-circle></label>
			</div>
			<div class="setting-field">
				<button style="position: relative; top:-5px; scale:0.75; transform-origin: left;" (click)="resetWarningsVisbility()" type="button" class="btn btn-danger">Reset</button>
			</div>
		</div>

		<div *ngIf="canTransferLinks" class="settings-container">
			<div class="setting-description">
				<label class="form-label">Export/Import configuration</label>
			</div>
			<div class="setting-field" style="display: flex; gap: 0.5rem; align-items: center;">
				<button style="scale: 0.75; transform-origin: left;" (click)="openExportPanel()" type="button" class="btn btn-primary">
				Export configuration
			  </button>
				<button style="scale: 0.75; transform-origin: left;" (click)="openImportPanel()" type="button" class="btn btn-secondary">
				Import configuration
			  </button>
			</div>
		</div>
	</div>
	<ng-template #loading>
		Loading...
	</ng-template>
</div>

<delete-link-modal></delete-link-modal>

<dx-popup [(visible)]="exportPopupVisible" [showCloseButton]="true" [showTitle]="true" title="Export link transfer code" [width]="700" [height]="'auto'" [dragEnabled]="true" [closeOnOutsideClick]="true">
	<form *ngIf="exportLinkConfigForm" [formGroup]="exportLinkConfigForm" class="admin-panel-grid">

		<!-- Left side: Switches -->
		<div class="left-panel">
			<div class="option-row">
				<dx-switch formControlName="includeFromLogin"></dx-switch>
				<label>Include from login</label>
			</div>
			<div class="option-row">
				<dx-switch formControlName="includeToLogin"></dx-switch>
				<label>Include to login</label>
			</div>
			<div class="option-row">
				<dx-switch formControlName="includeSettings"></dx-switch>
				<label>Include settings</label>
			</div>
			<div class="option-row">
				<dx-switch formControlName="includeEmailInfo"></dx-switch>
				<label>Include email info</label>
			</div>
			<div class="option-row">
				<dx-switch formControlName="useExplicitLinkName"></dx-switch>
				<label>Use explicit link name</label>
			</div>
			<!-- <div class="option-row">
				<dx-switch formControlName="includeLogs"></dx-switch>
				<label>Include Logs</label>
			</div> -->
		</div>

		<!-- Right side: Output and Button -->
		<div class="right-panel">
			<dx-text-area [value]="outputText$ | async" [height]="200" [readOnly]="true" placeholder="Output will appear here">
			</dx-text-area>

			<div class="button-row">
				<dx-button text="Generate link code" type="success" (onClick)="runBackendAction()" class="run-button" style="margin-right: 10px;">
				</dx-button>

				<dx-button text="Copy Output" type="default" (onClick)="copyOutputText()">
				</dx-button>
			</div>

		</div>
	</form>
</dx-popup>

<dx-popup [(visible)]="importPopupVisible" [showCloseButton]="true" [showTitle]="true" title="Import link transfer code" [width]="700" [height]="'auto'" [dragEnabled]="true" [closeOnOutsideClick]="true">
	<form *ngIf="importLinkConfigForm" [formGroup]="importLinkConfigForm" class="admin-panel-grid">

		<!-- Left side: Switches -->
		<div class="left-panel">
			<div class="option-row">
				<dx-switch formControlName="includeFromLogin"></dx-switch>
				<label>Import from login</label>
			</div>
			<div class="option-row">
				<dx-switch formControlName="includeToLogin"></dx-switch>
				<label>Import to login</label>
			</div>
			<div class="option-row">
				<dx-switch formControlName="includeSettings"></dx-switch>
				<label>Import settings</label>
			</div>
			<div class="option-row">
				<dx-switch formControlName="includeEmailInfo"></dx-switch>
				<label>Import email info</label>
			</div>
			<!-- <div class="option-row">
				<dx-switch formControlName="includeLogs"></dx-switch>
				<label>Include Logs</label>
			</div> -->
		</div>

		<!-- Right side: Output and Button -->
		<div class="right-panel">
			<!-- <dx-text-area [value]="outputText$ | async" [height]="200" [readOnly]="false" placeholder="Enter code here">
			</dx-text-area> -->

			<div class="text-area-row">
				<dx-text-area (onValueChanged)="onInputTextChanged($event)" [value]="inputText$ | async" [height]="200" [width]="300" [readOnly]="false" placeholder="Enter code here" style="flex: 1; margin-right: 10px;">
				</dx-text-area>

				<dx-text-area [value]="previewText$ | async" [height]="200" [readOnly]="true" placeholder="Preview output here" style="flex: 1;">
				</dx-text-area>

			</div>

			<div class="button-row">

				<dx-button text="Preview input" type="success" (onClick)="previewInputText()" style="margin-right: 10px;">
				</dx-button>

				<dx-button text="Import link configuration" type="danger" (onClick)="importLinkConfiguration()" class="run-button" style="margin-right: 10px;">
				</dx-button>

				<dx-button text="Copy Output" type="default" (onClick)="copyOutputText()">
				</dx-button>
			</div>

			<!-- <dx-text-area [value]="previewText$ | async" [height]="200" [readOnly]="true" placeholder="Preview output here">
			</dx-text-area> -->

		</div>
	</form>
</dx-popup>
